<template>
  <div class="application">
    <transition name="fade">
      <intro-section
        v-if="step == 1"
        :title="title"
        :body="body"
        :btn_text="btn_text"
        :icon="icon"
        v-on:next="goTo('/dashboard')"
      ></intro-section>
    </transition>
  </div>
</template>

<script>
import { db, functions } from "@/config/firebaseInit";
import Section from "@/components/Application/Section";

export default {
  name: "Complete",
  props: ["title", "body", "btn_text", "icon"],
  components: {
    "intro-section": Section
  },
  data() {
    return {
      step: 1,
      previous_step: 2
    };
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss">
.intro {
  height: auto;
  min-height: 100vh;
  background: rgba(11, 110, 251, 0.08);
  width: 100%;
  text-align: center;
  .contain {
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: 100vh;
    max-width: 700px;
    .icon {
      height: 70px;
      margin-bottom: 30px;
    }
    h1 {
      font-size: 50px;
    }
  }
}

.questions {
  max-width: 450px;
  width: 100%;
  margin: auto;
  margin-top: 30px;
}
</style>
